<template>
  <nav id="menu">
    <div class="d-flex mb-3 justify-content-between">
      <a @click="$emit('back')">
        <i class="far fa-chevron-left fa-1x"></i>
      </a>
      <h4 class="text-center">Navigation</h4>
      <a @click="$emit('close')">
        <i class="far fa-times fa-1x"></i>
      </a>
    </div>
    <forms class="m-1" @submitNavBar="submitNavBar" :scheme="data.propsScheme" :name="'NavBar'"></forms>
  </nav>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    submitNavBar(component) {
      this.$emit('saved', { props: component, name: this.data.componentName });
    }
  }
};
</script>
